import { compose } from 'redux';
import { connect } from 'react-redux';

import { loadable } from 'modules/layout';

import PinsList from '../components/PinsList';

import { selectPins, selectListPending } from '../services/selectors';

export default compose(
    connect(state => ({
        pins: selectPins(state),
        showLoader: selectListPending(state),
    })),
    loadable,
)(PinsList);
